var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reload 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2429 25.9271C19.4584 25.3429 23.6383 21.1736 24.2332 15.958C25.0139 9.13845 19.7134 3.33333 13.0691 3.25897V0.199728C13.0691 0.0297702 12.8566 -0.0605199 12.7132 0.0457038L6.41417 4.67175C6.30795 4.75141 6.30795 4.90544 6.41417 4.98511L12.7132 9.61115C12.8566 9.71737 13.0691 9.62177 13.0691 9.45712V6.40319C17.7376 6.47755 21.4767 10.4503 21.158 15.1985C20.8871 19.2828 17.557 22.597 13.4727 22.8572C9.14412 23.1334 5.46347 20.0423 4.80488 15.9527C4.68272 15.1932 4.01882 14.6408 3.25401 14.6408C2.30331 14.6408 1.55975 15.4853 1.70846 16.4254C2.63261 22.2518 8.01283 26.6229 14.2429 25.9271Z",
    fill: "#2C3E50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerm);
export default __webpack_public_path__ + "static/media/term.511bcbc068935ad45b3dd1b4d114656a.svg";
export { ForwardRef as ReactComponent };